export default __webpack_public_path__ + "static/media/list.c28f0411.svg";